import React from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import configData from '../utils/config/config.json';
import { useGlobalSpinnerActionsContext } from '../components/loader/useloader';
import useAuth from '../services/authContext';
import { useNavigate } from 'react-router-dom';
import { useNotificationActionsContext } from '../components/notificationModal/useModal';
import cryptoJs from 'crypto-js';
export const Context = React.createContext();

const generalOptions = {
  headers: {
    apikey: configData.amcKey,
  },
};

const ApiContext = ({ children }) => {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { authed, logout } = useAuth();
  const setNotifi = useNotificationActionsContext();
  const navigate = useNavigate();

  const getApiCalling = (url, options) => {
    return new Promise((resolve, reject) => {
      setGlobalSpinner(true);
      axios
        .get(`${configData.baseURLDev}${url}`, options)
        .then((response) => {
          resolve(response.data);
          setGlobalSpinner(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            handleResponse(err.response);
          }
          reject(err);
          setGlobalSpinner(false);
        });
    });
  };

  const getApiAuthCalling = (url, ishost) => {
    const generalOptionsAuth = {
      headers: {
        apikey: configData.amcKey,
        Authorization: `Bearer ${getSession('access_token')}`,
      },
    };
    return new Promise((resolve, reject) => {
      setGlobalSpinner(true);
      axios
        .get(`${ishost ? configData.baseURLDev : ''}${url}`, generalOptionsAuth)
        .then((response) => {
          resolve(response.data);
          setGlobalSpinner(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            handleResponse(err.response);
          }
          setGlobalSpinner(false);
          reject(err);
        });
    });
  };

  const getApiCallingReq = (url, data, options) => {
    return new Promise((resolve, reject) => {
      setGlobalSpinner(true);
      axios
        .get(`${configData.baseURLDev}${url}`, data, options)
        .then((response) => {
          resolve(response.data);
          setGlobalSpinner(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            handleResponse(err.response);
          }
          setGlobalSpinner(false);
          reject(err);
        });
    });
  };

  const postApiCalling = (url, postObj, options) => {
    return new Promise((resolve, reject) => {
      if(!(options?.noSpinner)){
        setGlobalSpinner(true);
      }
      axios
        .post(`${configData.baseURLDev}${url}`, postObj, generalOptions)
        .then((response) => {
          setGlobalSpinner(false);
          resolve(response.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            handleResponse(err.response);
          }
          console.log('Error in ' + url, err);
          setGlobalSpinner(false);
          reject(err);
        });
    });
  };
  const postApiwithOpCalling = (url, postObj, options, ishost) => {
    return new Promise((resolve, reject) => {
      setGlobalSpinner(true);
      axios
        .post(`${ishost ? configData.baseURLDev : ''}${url}`, postObj, options)
        .then((response) => {
          setGlobalSpinner(false);
          resolve(response.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            handleResponse(err.response);
          }
          console.log('Error in ' + url, err);
          setGlobalSpinner(false);
          reject(err);
        });
    });
  };
  const postApiAuthCalling = async (url, postObj, ishost) => {
    const generalOptionsAuth = {
      headers: {
        apikey: configData.amcKey,
        Authorization: `Bearer ${getSession('access_token')}`,
      },
    };
    return new Promise((resolve, reject) => {
      setGlobalSpinner(true);
      axios
        .post(
          `${ishost ? configData.baseURLDev : ''}${url}`,
          postObj,
          generalOptionsAuth
        )
        .then((response) => {
          setGlobalSpinner(false);
          resolve(response.data);
        })
        .catch((error) => {
          setGlobalSpinner(false);
          console.log(error);
          if (
            (error.response &&
              error.response.status &&
              error.response.status === 401) ||
            error?.status === 401
          ) {
            handleResponse(error.response).then(() => {
              console.log('Error in ' + url, error);

              reject(error);
            });
          } else {
            console.log('Error in fr' + url, error);
            setNotifi({ val: true, msg: 'Something went wrong' });
            setGlobalSpinner(false);
            reject(error);
          }
        });
    });
  };
  const handleResponse = async (response) => {
    console.log(response.status);

    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('access_token');
    logout().then(() => {
      navigate('/signIn');
    });
    setNotifi({ val: true, msg: 'Session Expired please login again' });
  };
  const getErrorMsg = (code, lang, options) => {
    var url = configData.errorMsgURl;
    var postObj = {
      amcCode: configData.amcCode,

      appCode: configData.appcode,

      errorCode: code,

      lngCode: configData.lang,
    };
    return new Promise((resolve, reject) => {
      axios
        .post(url, postObj, options)
        .then((response) => {
          resolve(response.data.data.errorMsg);
          setGlobalSpinner(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            handleResponse(err.response);
          }
          resolve(configData.defMsg);
          setGlobalSpinner(false);
        });
    });
  };
  const setSession = (data, dataname) => {
    var dataEnc = encryption(data);
    sessionStorage.setItem(dataname, dataEnc);
  };
  const getSession = (dataname) => {
    var dataEnc = sessionStorage.getItem(dataname);
    var data = null;
    data = dataEnc ? decryption(dataEnc) : '';

    return data;
  };
  const encryption = (body) => {
    return CryptoJS.AES.encrypt(
      JSON.stringify(body),
      'COREAPIV012021NDRS'
    ).toString();
  };
  const decryption = (body) => {
    const Bytes = CryptoJS.AES.decrypt(body, 'COREAPIV012021NDRS');
    return JSON.parse(Bytes.toString(CryptoJS.enc.Utf8));
  };
  const decryptionCesData = (bodyinp) => {
    const key = new Buffer(
      'dSvXm8kf8HErSQBX3dWSLo0VQis0Q52epST37u/59jU=',
      'base64'
    );
    const iv = new Buffer(16);
    const hexToByt = hexToBytes(bodyinp);
    console.log(hexToByt);
    console.log(key);
    const decrypto = CryptoJS.createDecryptor('aes', key, iv, {
      padding: CryptoJS.pad.Pkcs7,
    });
    var result = decrypto.update(hexToByt, 0, hexToByt.length);
    result += decrypto.final();
    return result;
  };
  const hexToBytes = (hex) => {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
  };

  return (
    <Context.Provider
      value={{
        getApiCalling,
        postApiCalling,
        getApiCallingReq,
        getErrorMsg,
        setSession,
        getSession,
        encryption,
        decryptionCesData,
        decryption,
        postApiAuthCalling,
        getApiAuthCalling,
        postApiwithOpCalling,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default ApiContext;
